<template>
	<AppFooterWrapper class="create-subflow-footer" v-if="isSelectingWorkflowRoute" @cancel="cancel">
		<span class="flex-centerize footer-text">
			Select the step range you wish to convert into a subflow and click continue
			<OutlinedButton class="ml-8" @click="openCreateSubflowDialog" :disabled="!isRouteSelected"> Continue </OutlinedButton>
		</span>
	</AppFooterWrapper>
</template>

<script>
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { setIsSelectingWorkflowRoute, setIsRouteSelected } from '@/store/modules/workflowGraphs/actions';
import { isSelectingWorkflowRoute, isRouteSelected } from '@/store/modules/workflowGraphs/getters';
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';

import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

import AppFooterWrapper from './AppFooterWrapper';

export default {
	name: 'CreateSubflowFooter',
	components: {
		AppFooterWrapper,
	},
	computed: {
		...mapGettersShorthand({ isSelectingWorkflowRoute, isRouteSelected, editWorkflow }),
	},
	methods: {
		...mapActionsShorthand({ setIsSelectingWorkflowRoute, setIsRouteSelected }),
		async openCreateSubflowDialog() {
			const ret = await AppDialogManagerService.openConvertToSubflowBlockDialog({
				projectId: this.editWorkflow.project,
			});
			if (ret) {
				this.cancel();
			}
		},
		cancel() {
			this.setIsSelectingWorkflowRoute(false);
			this.setIsRouteSelected(false);
		},
	},
};
</script>

<style scoped lang="scss">
.create-subflow-footer {
	&.v-footer {
		background-color: var(--bold-border-color) !important;
	}
	.footer-text {
		color: var(--white);
	}
}
</style>
